import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import ReactGA from "react-ga4";
import { ContextLayout } from "./contexts";
import GlobalStyle from "./styles/globalStyles";
import { ANALYTICS_KEY, TAG_MANAGER_KEY } from "./env";
import TagManager from 'react-gtm-module';

ReactGA.initialize(ANALYTICS_KEY, {
  gaOptions: {
    cookie_flags: "secure;samesite=none",
  },
});

const tagManagerArgs = {
  gtmId: TAG_MANAGER_KEY
}

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <ContextLayout>
      <App />
    </ContextLayout>
  </React.StrictMode>,
  document.getElementById("root")
);